export default "__VITE_ASSET__CgXZdZoZ__"